export const version = '2.15.4';
//# sourceMappingURL=version.js.map